import React from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {Box, BoxProps, Button, Typography} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {ReactComponent as ChatIcon} from '@progyny/assets/images/chat-icon.svg'

interface QuestionBannerProps {
  boxProps?: BoxProps
  width?: number
}

const useStyles = makeStyles<{width: number}>()((theme, {width}) => ({
  container: {
    position: 'relative',
    backgroundColor: '#E7EDF9',
    height: 240,
    width: width,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'flex-start',
    borderRadius: 16,
    padding: 40,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      width: '100%',
      padding: 24,
      backgroundPosition: 'bottom right',
      gap: theme.spacing(2),
    },
  },
  icon: {
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      top: 24,
      right: 24,
      opacity: 0.6,
      '& svg': {
        width: 80,
        height: 64,
      },
    },
  },
  button: {
    color: theme.palette.other.brandColors.white,
    fontWeight: '500',
    fontSize: 16,
    '&:hover': {
      backgroundColor: theme.palette.other.brandColors.primary,
      color: theme.palette.other.brandColors.white,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
  },
}))

const QuestionBanner: React.ComponentType<QuestionBannerProps> = ({
  boxProps,
  width,
}: QuestionBannerProps) => {
  const {classes} = useStyles({width: width || 720})
  const history = useHistory()
  const {t} = useTranslation()

  return (
    <Box className={classes.container} {...boxProps}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
        height='100%'
        flex={1}
      >
        <Box>
          <Typography variant='h4' gutterBottom>
            {t(
              'knowledge_center_article_details_topic_details_question_banner_want_to'
            )}
          </Typography>
          <Typography variant='body2'>
            {t('card_user_steps_personal_private_and_free')}
          </Typography>
        </Box>
        <Button
          className={classes.button}
          variant={'contained'}
          onClick={() => {
            history.push('/consultations')
          }}
        >
          {t(
            'knowledge_center_article_details_topic_details_question_banner_book_fr'
          )}
        </Button>
      </Box>
      <Box className={classes.icon}>
        <ChatIcon />
      </Box>
    </Box>
  )
}

export default QuestionBanner
